module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Compagnies","all-companies-selected":"Toutes"},"en":{"title":"Airlines","all-companies-selected":"All"}}')
  delete Component.options._Ctor
}
